import { Table } from 'antd'
import type { TableProps } from 'antd'

interface DataTableProps<T> extends TableProps<T> {
  total?: number
  page?: number
  pageSize?: number
  onPageChange?: (page: number, pageSize: number) => void
}

export default function DataTable<T extends object>({
  total,
  page,
  pageSize = 20,
  onPageChange,
  ...tableProps
}: DataTableProps<T>) {
  return (
    <Table<T>
      {...tableProps}
      pagination={
        total !== undefined
          ? {
              total,
              current: page,
              pageSize,
              onChange: onPageChange,
              showSizeChanger: true,
              showTotal: (t) => `Total ${t} items`,
            }
          : false
      }
      size="middle"
    />
  )
}
